import React, { useContext } from 'react';
import { FiXCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Input, Row, Table } from 'reactstrap';
import { Image, H5, H6, Btn } from '../../../AbstractElements';
import { Action, CartTitle, Price, Product, ProductName, Quantity, Total } from '../../../Constant';
import CartContext from '../../../Context/Ecommerce/Cart';
import ProductContext from '../../../Context/Ecommerce/Product';

import CartFooter from './CartFooter';

const CartTable = () => {
  const { symbol } = useContext(ProductContext);
  const { addToCart, cart, decrementQty, removeFromCart } = useContext(CartContext);
  const incrementQty = (product, quantity) => {
    addToCart(product, quantity);
  };
  const decrementQuantity = (id) => {
    decrementQty(id);
  };
  const removefromcart = (item) => {
    removeFromCart(item.id);
  };

  return (
    <>
      <Col sm='12'>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{CartTitle}</H5>
          </CardHeader>
          <CardBody>
            <Row>
              <div className='order-history table-responsive wishlist'>
                <Table className='table table-bordered'>
                  <thead>
                    <tr>
                      <th>{Product}</th>
                      <th>{ProductName}</th>
                      <th>{Price}</th>
                      <th>{Quantity}</th>
                      <th>{Action}</th>
                      <th>{Total}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart &&
                      cart.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <Image className='img-40 mx-auto' src={require(`../../../assets/images/${item.img}`)} alt='#' />
                          </td>
                          <td>
                            <div className='product-name'>
                              <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
                                <H6>{item.name}</H6>
                              </Link>
                            </div>
                          </td>
                          <td>
                            {symbol}
                            {item.price}
                          </td>
                          <td>
                            <fieldset className='qty-box'>
                              <div className='input-group bootstrap-touchspin'>
                                <span className='input-group-prepend'>
                                  <Btn color='primary' className='btn btn-primary btn-square bootstrap-touchspin-down' onClick={(e) => decrementQuantity(item.id)}>
                                    <i className='fa fa-minus'></i>
                                  </Btn>
                                </span>
                                <Input type='text' name='quantity' value={item.qty} readOnly={true} style={{ textAlign: 'center' }} className='form-control input-number' />
                                <span className='input-group-append'>
                                  <Btn color='primary' className='btn btn-primary btn-square bootstrap-touchspin-up' onClick={(e) => incrementQty(item, 1)}>
                                    <i className='fa fa-plus'></i>
                                  </Btn>
                                </span>
                              </div>
                            </fieldset>
                          </td>
                          <td>
                            <FiXCircle onClick={(e) => removefromcart(item)} style={{ width: 24, height: 24 }} />
                          </td>
                          <td>
                            {symbol}
                            {item.price * item.qty}
                          </td>
                        </tr>
                      ))}
                    <CartFooter symbol={symbol} cart={cart} />
                  </tbody>
                </Table>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default CartTable;
